module.exports = __webpack_public_path__ + "media/images/sites/health/favicon-96x96-f66a855149a52d1a278603a356ac3eb8.png";